import { Locale } from '../types';

export const locales = ['en', 'pl'] as const;

export default function checkIsLocale(value: string): value is Locale {
  return locales.includes(value as Locale);
}
